import { gql } from '__generated__';

export default gql(`
  mutation DeleteReview($id: ID!) {
    deleteReview(id: $id)
  }
`);
